import { useMemo } from "react";
import { isObject } from "@perxis-auto/shared";
import "../../internal/features/forms/middleware.js";
import "../../internal/features/forms/reducer.js";
import { selectAll } from "../../internal/features/forms/selectors.js";
import "../../internal/features/stages/middleware.js";
import "../../internal/features/stages/reducer.js";
import { selectAllFields } from "../../internal/features/stages/selectors.js";
import { useAppSelector } from "../../internal/shared/lib/store/hooks/useAppSelector.js";
function useFinalResult() {
  const forms = useAppSelector(selectAll);
  const allFields = useAppSelector(selectAllFields);
  const finalResult = useMemo(() => {
    const result = {};
    for (const form of forms) {
      if (isObject(form.result) && "avg" in form.result && "min" in form.result && "max" in form.result) {
        Object.assign(result, form.result);
      }
      if (isObject(form.fields) && !form.error) {
        const valuesWithLabel = Object.entries(form.fields).reduce(
          (acc, [fieldId, fieldValue]) => {
            var _a;
            const field = allFields.find((field2) => field2.id === fieldId);
            const fieldErrors = (_a = form.fieldsErrors) == null ? void 0 : _a[fieldId];
            if (fieldErrors) {
              return acc;
            }
            return {
              ...acc,
              [fieldId]: {
                label: field == null ? void 0 : field.label,
                value: fieldValue
              }
            };
          },
          {}
        );
        Object.assign(result, valuesWithLabel);
      }
    }
    return result;
  }, [allFields, forms]);
  return {
    data: finalResult
  };
}
export {
  useFinalResult
};
